import React, { useEffect } from 'react';
import { PrimaryButton, TertiaryButton } from '@workday/canvas-kit-react/button';
import { Checkbox } from '@workday/canvas-kit-react/checkbox';
import { ID_CANCEL_BUTTON, ID_SUBMIT_BUTTON } from '../../../../autoIds';
import { autoId } from '@workday/upc-common';
import '../../SettingsModalContent.scss';
import { useGetUserSettingsQuery, useUpdateUserSettingsMutation } from '../../../../slices/account-api.slice';
import { LoadingDots } from '@workday/canvas-kit-react';
import { useTranslation } from 'react-i18next';

export function EmailPreferences({ onCancel }) {
    const { t } = useTranslation('account');
    const [provisioning, setProvisioning] = React.useState(false);

    // @ts-ignore
    const { data, isLoading, isSuccess: isUserSettingsSuccess } = useGetUserSettingsQuery();

    useEffect(() => {
        if (isUserSettingsSuccess) {
            const enableProvisioning = data?.emailPreferences?.enableProvisioning ?? true;
            setProvisioning(enableProvisioning);
        }
    }, [isUserSettingsSuccess, data]);

    const [updateUserSettings, { isSuccess }] = useUpdateUserSettingsMutation();

    useEffect(() => {
        if (isSuccess && onCancel) {
            onCancel();
        }
    }, [isSuccess, onCancel]);

    function onSubmit(e) {
        e.preventDefault();
        const payload = {
            emailPreferences: { enableProvisioning: provisioning }
        };
        updateUserSettings(payload);
    }

    return (
        <div className='settingsModalContent'>
            <form onSubmit={onSubmit}>
                <h1>{t('EmailPreferences.emailNotification')}</h1>
                <h2>{t('EmailPreferences.selectYourEmail')}</h2>
                {isLoading ? (
                    <LoadingDots />
                ) : (
                    <>
                        <div className='settingsModalContent__options'>
                            <div className='settingsModalContent__checkbox'>
                                <Checkbox
                                    /* @ts-ignore */
                                    label={t('EmailPreferences.tenantAccess')}
                                    checked={provisioning}
                                    onChange={() => setProvisioning(prev => !prev)}
                                />
                                <div className='settingsModalContent__checkboxText'>
                                    {t('EmailPreferences.receiveAnEmail')}
                                </div>
                            </div>
                        </div>
                        <div className='settingsModalContent__footer'>
                            <PrimaryButton {...autoId(ID_SUBMIT_BUTTON)} type='submit' size={'large'}>
                                {t('EmailPreferences.submitButton')}
                            </PrimaryButton>
                            <br />
                            <div className='settingsModalContent__cancel'>
                                <TertiaryButton
                                    {...autoId(ID_CANCEL_BUTTON)}
                                    type='button'
                                    size='large'
                                    onClick={onCancel}>
                                    {t('Common.cancel', { ns: 'shared' })}
                                </TertiaryButton>
                            </div>
                        </div>
                    </>
                )}
            </form>
        </div>
    );
}
